import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import DeliveryFleetListComponent from '../../../../components/management/fleets/data/DeliveryFleetListComponent'
import { getDeliveriesDetailsFleet, getDeliveriesDetailsFleetSuccess, getDossierDetailsFleet } from '../../../../actions/management/management'
import { openModal } from '../../../../actions/common'
import { setOperateActionPrintDeliveryNoteProcess } from '../../../../actions/unattendedProcess/unattendedProcess'
import { openDataDeliveryFleetModal, openDeliveryDetailsFleetModal } from '../../../../actions/management/auxModals/auxModals'
import TrackingContainer from '../../../tracking/trackingContainer'

export function mapStateToProps (state) {
  return {
    ...state.management.deliveryFleetComponent,
    dossierFleetDetails: state.management.dossierFleetDetails
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      getDeliveriesDetailsFleet,
      getDeliveriesDetailsFleetSuccess,
      getDossierDetailsFleet,
      openModal,
      setOperateActionPrintDeliveryNoteProcess,
      openDataDeliveryFleetModal,
      openDeliveryDetailsFleetModal
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(TrackingContainer(DeliveryFleetListComponent, true)))
